import { render } from "./glass.vue?vue&type=template&id=8dd28f1c&scoped=true"
import script from "./glass.vue?vue&type=script&lang=js"
export * from "./glass.vue?vue&type=script&lang=js"

import "./glass.vue?vue&type=style&index=0&id=8dd28f1c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8dd28f1c"]])

export default __exports__